
import { PremierServiceProductDTO } from "../DTO/premierServiceProductDTO";

export class PremierServiceProduct{
    public id!: number;
    public serviceId!: number;
    public name!: string;
    public productTypeId!: string;
    public contextType!: string; //i.e. FileDefinition
    public contextId!: number; //i.e. FileDefinitionId; if used in a data request, this defines what type of file format (filedefinition) the data will be returned abd also makes sure this service product can only be used in a moov related to same filedefinition.
    public parameterTemplate!: IServiceParameter[];
    public canSchedule!: boolean;
    public restrictedToMoovStepDefinitionId!: number;
    public enabled!: boolean;
    public added!: Date;
    public edited!: Date;

    public static mapFromDTO(param:PremierServiceProductDTO):PremierServiceProduct{
        if (!param) throw new Error("parameter is null")
        let obj = new PremierServiceProduct();
        try
        {
            obj.id = param.id;
            obj.serviceId = param.serviceId;
            obj.name = param.name;
            obj.productTypeId = param.productTypeId;
            obj.contextType = param.contextType;
            if(param.contextId) obj.contextId = param.contextId;
            obj.parameterTemplate = JSON.parse(param.parameterTemplate);
            obj.canSchedule = param.canSchedule;
            obj.restrictedToMoovStepDefinitionId = param.restrictedToMoovStepDefinitionId;
            obj.enabled = param.enabled;
            if(param.added) obj.added = new Date(param.added);
            if(param.edited) obj.edited = new Date(param.edited);
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:PremierServiceProduct):PremierServiceProductDTO{
        if (!param) throw new Error("parameter is null")
        let dto = new PremierServiceProductDTO();
        try
        {
            dto.id = param.id;
            dto.serviceId = param.serviceId;
            dto.name = param.name;
            dto.productTypeId = param.productTypeId;
            dto.contextType = param.contextType;
            if(param.contextId) dto.contextId = param.contextId;
            dto.parameterTemplate = JSON.stringify(param.parameterTemplate);
            dto.canSchedule = param.canSchedule;
            dto.restrictedToMoovStepDefinitionId = param.restrictedToMoovStepDefinitionId;
            dto.enabled = param.enabled;
            if(param.added) dto.added = param.added.toISOString();
            if(param.edited) dto.edited = param.edited.toISOString();
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}

export interface IServiceParameterOption{
    id:number;
    label:string;
    parameters:IServiceParameter[];
}

export interface IServiceParameter{
    label:string;
    name:string;
    inputType:string; //possible values are: slt=single line text, mlt=multi line text, sel=selection, msel=multi-select, num=numeric, eml=email
    mandatory:boolean;
    options:string[];
    defaultIndex:number;
    defaultIndexes?:number[]; //msel only; takes precedence over defaultIndex
    forceDefaultIndex:boolean;
    numDecimals?:boolean; //num only; default false (whole numbers)
    numMin?:number; //num only
    numMax?:number; //num only
    numDefault?:number; //num only
    optionDescriptions:string[];
}